import React from "react";

import FaqSection from "../components/faqSection/FaqSection";

const Faq = () => {
  return (
    <>
      <FaqSection />
    </>
  );
};

export default Faq;